import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { doctorActions } from "../../core/actions";
import BtnCellRenderer from "../common/BtnCellRenderer";
import {
  ROOM,
  ROOM_STATUS_BOOKED,
  ROOM_STATUS_AVAILABLE,
  ROOM_CATEGORIES,
} from "../../shared/constants/index";
import { roomList } from "../../core/actions/roomMasterActions";
import { helperServices } from "../../shared/helper";
import Components from "./index";
import { format } from "date-fns";
import {
  Button,
  FormControlLabel,
  DialogContent,
  Switch,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
} from "@mui/material";

import { Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
function Room(props) {
  const checkinDateRef = useRef(null);
  const checkinTimeRef = useRef(null);
  const assignBtnRef = useRef(null);
  const toggleSwitchRef = useRef(null);
  const gridRef = useRef();
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [currentSelectedRoomId, setSelectedRoomId] = useState(null);
  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(10);
  const [roomData, setRoomData] = useState([]);
  const [assignedRoom, setAssignedRoom] = useState();
  const [patient, setPatient] = useState();
  const [reloadRoomData, setReloadRoomData] = useState(false);
  const [roomSelected, selectedRoom] = useState();
  const [minAllowedDate, setMinAllowedDate] = useState("");
  const [openRoomModal, setOpenRoomModal] = useState(props.assignRoom);
  const [showEmergency, setShowEmergency] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [admissionDate, setAdmissionDate] = useState("");
  const [admissionTime, setAdmissionTime] = useState("");
  const [showEarlyCheckinWarning, setShowEarlyCheckinWarning] = useState(false);
  const [admissionDateTime, setAdmissionDateTime] = useState(null);
  const closeButtonRef = useRef(null);

  var ServerResVal = ServerRes;
  const dispatch = useDispatch();
  const columnDefs = useMemo(
    () => [
      {
        headerName: "Id",
        field: "id",
        sortable: true,
        filter: true,
        flex: 0.5,
        resizable: true,
        floatingFilter: true,
      },
      {
        headerName: "Room Name",
        field: "roomName",
        sortable: true,
        filter: true,
        flex: 1,
        resizable: true,
        floatingFilter: true,
        onGridReady: "open",
      },
      {
        headerName: "Floor Id",
        field: "floorId",
        sortable: true,
        filter: true,
        flex: 0.5,
        resizable: true,
        floatingFilter: true,
      },
      {
        headerName: "Description",
        field: "description",
        sortable: true,
        filter: true,
        flex: 1,
        resizable: true,
        floatingFilter: true,
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        filter: true,
        flex: 0.75,
        resizable: true,
        floatingFilter: true,
      },
      {
        headerName: "Type",
        field: "type",
        sortable: true,
        filter: true,
        flex: 1,
        resizable: true,
        floatingFilter: true,
      },
      {
        headerName: "Actions",
        field: "Actions",
        sortable: true,
        filter: true,
        flex: 0.5,
        resizable: true,
        width: 150,
        headerCheckboxSelection: false,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
      },
    ],
    [],
  );

  const context = { componentParent: (props) => handleRendererCall(props) };

  const getCurrentDateTime = () => {
    const now = new Date();

    const date = now.toISOString().split("T")[0];

    const time = now.toTimeString().slice(0, 5);

    return { date, time };
  };
  useEffect(() => {
    if (!openRoomModal) return;

    if (assignedRoom?.roomStatus?.checkinDate) {
      const checkin = new Date(assignedRoom.roomStatus.checkinDate);
      const checkinDateStr = checkin.toISOString().split("T")[0];
      const checkinTimeStr = checkin.toTimeString().slice(0, 5);

      setAdmissionDate(checkinDateStr);
      setAdmissionTime(checkinTimeStr);
      setMinAllowedDate(checkinDateStr);
    } else {
      const { date, time } = getCurrentDateTime();
      setAdmissionDate(date);
      setAdmissionTime(time);
      setMinAllowedDate(date);
    }
  }, [openRoomModal, assignedRoom]);

  useEffect(() => {
    if (openRoomModal) {
      setTimeout(() => {
        checkinDateRef.current?.focus();
      }, 0);
    }
  }, [openRoomModal]);

  const handleDateKeyDown = (e) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      checkinTimeRef.current?.focus();
    }
  };

  const handleTimeKeyDown = (e) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      assignBtnRef.current?.focus();
    }
  };

  const handleAssignKeyDown = (e) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      toggleSwitchRef.current?.focus();
    }
  };

  useEffect(() => {
    if (!admissionDateTime || !admissionDate || !admissionTime) {
      setShowEarlyCheckinWarning(false);
      return;
    }
    const selectedDateTime = new Date(`${admissionDate}T${admissionTime}`);
    if (selectedDateTime < admissionDateTime) {
      setShowEarlyCheckinWarning(true);
    } else {
      setShowEarlyCheckinWarning(false);
    }
  }, [admissionDate, admissionTime, admissionDateTime]);

  useEffect(() => {
    if (props && props.patientInfo && props.patientInfo.visitId) {
      setPatient(props.patientInfo);
      if (props.patientInfo.admsnDate) {
        const [month, day, year, time] = props.patientInfo.admsnDate.split(" ");
        const timeParts = time ? time.split(":") : ["00", "00"];
        const monthIndex = new Date(`${month} 1, 2020`).getMonth();
        const admissionDateTime = new Date(
          parseInt(year),
          monthIndex,
          parseInt(day),
          parseInt(timeParts[0] || 0),
          parseInt(timeParts[1] || 0),
        );
        setAdmissionDateTime(admissionDateTime);
      } else {
        setAdmissionDateTime(null);
      }
    }
  }, [props]);

  useEffect(() => {
    console.log("Props data in the room component ::", props);
    getRoomsList();
  }, []);

  const handleRendererCall = (params) => {
    setRoomData((prev) =>
      prev.map((room) =>
        room.id === params.data.id
          ? { ...room, checked: true, assignedroom: true }
          : { ...room, checked: false, assignedroom: false },
      ),
    );

    selectedRoom({ ...params.data });
    setReloadRoomData(!reloadRoomData);
  };

  const handleToggleKeyDown = (e) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      closeButtonRef.current?.focus();
    }
  };

  const handleCloseKeyDown = (e) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      checkinDateRef.current?.focus();
    }
  };

  const assignSelectedRoom = async (event) => {
    if (!admissionDate || !admissionTime) {
      setServerRes({
        success: "",
        error: "Please select admission date and time",
      });
      setTimeout(() => closeAlert(), 3000);
      return;
    }
    if (assignedRoom?.emergencystatus !== true && !roomSelected) {
      setServerRes({ success: "", error: "Please select a room" });
      setTimeout(() => {
        closeAlert();
      }, 3000);
    }

    setIsAssigning(true);
    try {
      if (
        !roomSelected &&
        assignedRoom &&
        assignedRoom.emergencystatus === true
      ) {
        await roomCheckout(assignedRoom, "checkout");
        return;
      }

      if (roomSelected && roomSelected.id !== currentSelectedRoomId) {
        await roomCheckout(roomSelected);
        return;
      }

      if (roomSelected && roomSelected.id === currentSelectedRoomId) {
        props.closeRoomModal(ServerResVal);
      }
    } catch (err) {
      setServerRes({ success: "", error: "An unexpected error occurred" });
    } finally {
      setIsAssigning(false);
    }
  };

  const getRoomsList = () => {
    // This assign-room screen requests admission-room categories explicitly.
    // The room API applies the category filter without deriving it from patient type.
    const data = {
      facilityId: "",
      roomStatus: [],
      roomCategories: [
        ROOM_CATEGORIES.ADMISSION_ROOM,
      ],
    };
    dispatch(
      doctorActions.getRoomList(data, (resCb) => {
        if (resCb && resCb.roomList) {
          dispatch(doctorActions.setPageHeader(ROOM));
          let roomList = Object.values(resCb.roomList).map((item) => ({
            ...item,
            id: item.id,
            roomName: item.roomName,
            floorId: item.floorId,
            status: item.roomStatus?.bookstatus || "available",
            type: item.type,
            description: item.description,
            // Preserve the server's room category in the grid row. The category
            // identifies whether this room is eligible for inpatient admission.
            roomCategory: item.roomCategory,
            assignedroom: false,
            linkedblockrooms: item?.linkedblockrooms || null,
          }));
          const availableRooms = roomList.filter((room) =>
            room.status === "available",
          );
          setRoomData(availableRooms);
          getAssignedRoom(props.patientInfo, roomList);
        }
      }),
    );
  };

  const getAssignedRoom = (data, fullRoomList) => {
    if (!data || !data.visitId) {
      setAssignedRoom(null);
      return;
    }

    const patientData = { ...data, visitid: data.visitId };
    const bookedRooms = fullRoomList.filter((r) => r.status === "booked");
    console.log("bookedRooms", bookedRooms);

    const blockedIds = new Set();

    bookedRooms.forEach((room) => {
      const blockInfo = room?.linkedblockrooms?.blockedBy;
      if (!blockInfo) return;

      blockInfo
        .split(",")
        .map((id) => Number(id.trim()))
        .forEach((id) => blockedIds.add(id));
    });

    const blockedByMap = new Map();

    fullRoomList.forEach((room) => {
      const blockedBy = room?.linkedblockrooms?.blockedBy;
      if (!blockedBy) return;

      blockedBy
        .split(",")
        .map((id) => Number(id.trim()))
        .forEach((blockingId) => {
          if (!blockedByMap.has(room.id)) {
            blockedByMap.set(room.id, new Set());
          }
          blockedByMap.get(room.id).add(blockingId);
        });
    });

    const bookedRoomIds = new Set(
      bookedRooms
        .filter((r) => r.roomStatus?.bookstatus === "booked")
        .map((r) => r.id),
    );

    dispatch(
      doctorActions.getAssignedRoom(patientData, (resCb) => {
        if (resCb?.room?.id) {
          const assignedRoom = { ...resCb.room };
          const assignedStatus =
            assignedRoom.roomStatus?.bookstatus || "occupied";

          setAssignedRoom(assignedRoom);

          let updatedList = fullRoomList.map((item) => {
            if (item.id === assignedRoom.id) {
              return {
                ...item,
                visitid: assignedRoom.visitid || assignedRoom.visitId,
                assignedroom: true,
                status: assignedStatus,
              };
            }
            return {
              ...item,
              assignedroom: false,
            };
          });

          if (!updatedList.some((r) => r.id === assignedRoom.id)) {
            updatedList.push({
              ...assignedRoom,
              assignedroom: true,
              status: assignedStatus,
              visitid: assignedRoom.visitid || assignedRoom.visitId,
            });
          }

          updatedList = updatedList.filter((r) => {
            if (r.id === assignedRoom.id) return true;
            if (r.roomStatus?.bookstatus === "booked") return false;
            const blockedByRooms = blockedByMap.get(r.id);

            if (blockedByRooms) {
              for (const blockerId of blockedByRooms) {
                if (
                  bookedRoomIds.has(blockerId) &&
                  blockerId !== assignedRoom.id
                ) {
                  return false;
                }
              }
            }
            return true;
          });

          const assigned = updatedList.find((r) => r.id === assignedRoom.id);
          if (assigned) {
            updatedList = [
              assigned,
              ...updatedList.filter((r) => r.id !== assignedRoom.id),
            ];
          }
          setRoomData([...updatedList]);
          setReloadRoomData((prev) => !prev);
          setSelectedRoomId(assignedRoom.id); // optional: auto-select
        } else {
          let availableRooms = fullRoomList.filter(
            (r) => r.status === "available" && !blockedIds.has(r.id),
          );
          setRoomData(availableRooms);
          setAssignedRoom(null);
          setReloadRoomData((prev) => !prev);
        }
      }),
    );
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const isRowSelectable = useMemo(() => {
    return (params) => {
      return (
        !!params.data &&
        params.data.roomStatus &&
        params.data.roomStatus.bookstatus != "closed"
      );
    };
  }, []);

const onSelectionChanged = (e) => {
  const selectedRows = e.api.getSelectedRows();
  selectedRoom(selectedRows[0] || null);
};

  const getRowStyle = useCallback((params) => {
    if (
      params.data?.visitid === null &&
      params.data?.roomStatus?.bookstatus === "booked"
    ) {
      return { background: "lightgray" };
    }
  }, []);

  const getRowClass = useCallback((params) => {
    if (
      params.data?.visitid === null &&
      params.data?.roomStatus?.bookstatus === "booked"
    ) {
      return "disable-row";
    }
  }, []);

  function onRowDataChanged(e) {
    gridRef.current.api.forEachNode((node) => {
      if (node.data.assignedroom) {
        node.setSelected(true);
      }
    });
  }

  const closeRoomModal = () => {
    props.closeRoomModal();
  };

  const getFormateDate = (date) => {
    if (!date) return "-";
    const reqdate = new Date(date);
    if (Number.isNaN(reqdate.getTime())) return "-";
    let formatedate = format(reqdate, "MMM dd yyyy");
    return formatedate;
  };

  const toggleRooms = () => {
    if (showEmergency) {
      getRoomsList();
    } else {
      showemergencyrooms();
    }
    setShowEmergency(!showEmergency);
  };

  const showemergencyrooms = () => {
    let data = { facilityId: "", roomStatus: [] };
    dispatch(
      doctorActions.getEmergencyRoomList(data, (resCb) => {
        if (resCb) {
          if (resCb.roomList) {
            dispatch(doctorActions.setPageHeader(ROOM));
            let roomList = Object.values(resCb.roomList);
            for (let item of roomList) {
              item["id"] = item.id;
              item["roomName"] = item.roomName;
              item["floorId"] = item.floorId;
              item["status"] = item.emergencyroomstatus.bookstatus
                ? item.emergencyroomstatus.bookstatus
                : "available";
              item["type"] = item.type;
              item["description"] = item.description;
              item["roomStatus"] = item.emergencyroomstatus;
              if (assignedRoom && assignedRoom.id === item.id) {
                item["visitid"] = item.visitId;
                item["assignedroom"] = true;
              } else {
                item["assignedroom"] = false;
              }
            }
            setRoomData([...roomList]);
            getAssignedEmergencyRoom(props.patientInfo, roomList);
          }
        }
      }),
    );
  };

  const getAssignedEmergencyRoom = (data, list) => {
    if (data && data.visitId) {
      let patientData = { ...data, visitid: data.visitId };
      dispatch(
        doctorActions.getAssignedEmergencyRoom(patientData, (resCb) => {
          if (resCb && resCb.room && resCb.room.id) {
            setAssignedRoom(resCb.room);
            let updatedList = list.map((item) => {
              if (item.id === resCb.room.id) {
                setSelectedRoomId(item.id);
                return {
                  ...item,
                  visitid: resCb.room.visitid,
                  assignedroom: true,
                  status:
                    resCb.room.emergencyroomstatus?.bookstatus || "available",
                };
              }
              return { ...item, assignedroom: false };
            });

            if (!updatedList.some((r) => r.id === resCb.room.id)) {
              updatedList.push({
                ...resCb.room,
                assignedroom: true,
                status:
                  resCb.room.emergencyroomstatus?.bookstatus || "available",
              });
            }
            updatedList = updatedList.filter(
              (r) => r.status === "available" || r.id === resCb.room.id,
            );
            const assignedRoom = updatedList.find(
              (r) => r.id === resCb.room.id,
            );
            if (assignedRoom) {
              updatedList = [
                assignedRoom,
                ...updatedList.filter((r) => r.id !== resCb.room.id),
              ];
            }

            setRoomData([...updatedList]);
            setReloadRoomData((prev) => !prev);
          } else {
            const availableList = list.filter((r) => r.status === "available");
            setRoomData([...availableList]);
            setReloadRoomData((prev) => !prev);
            setAssignedRoom(null);
          }
        }),
      );
    }
  };

  const roomCheckout = (data, mode = "assign") => {
    if (!assignedRoom) {
      console.log("mode:", mode);
      if (mode === "assign") {
        return assignRoom(data);
      }
      return Promise.resolve();
    }

    let room = { ...assignedRoom };
    const username = helperServices.getLoggedUserName();

    if (mode === "assign" && admissionDate && admissionTime) {
      const checkoutDateTime = new Date(`${admissionDate}T${admissionTime}`);
      room.checkoutDateTime = checkoutDateTime.toISOString();
    }

    if (room.emergencystatus === true) {
      room.emergencyroomstatus = room.emergencyroomstatus || {};
      room.emergencyroomstatus.uby = username;
      room.emergencyroomstatus.cby = username;
      room.emergencyroomstatus.bookstatus = ROOM_STATUS_AVAILABLE;
    } else {
      room.roomStatus = room.roomStatus || {};
      room.roomStatus.uby = username;
      room.roomStatus.cby = username;
      room.roomStatus.bookstatus = ROOM_STATUS_AVAILABLE;
    }
    room.visitid = patient.visitId;

    return new Promise((resolve) => {
      dispatch(
        doctorActions.roomCheckout(room, async (resCb) => {
          console.log("mode:", mode);
          if (resCb && mode === "assign") {
            await assignRoom(data);
            resolve(resCb);
          } else if (resCb && mode === "checkout") {
            if (resCb.successMessages) {
              ServerResVal.success = "Room checked out successfully";
              setServerRes({ ...ServerResVal });
              props.closeRoomModal(ServerResVal);
            }
            if (resCb.errorMessages) {
              ServerResVal.error = "Failed to checkout room";
              setServerRes({ ...ServerResVal });
              props.closeRoomModal(ServerResVal);
            }
            getRoomsList();
            resolve(resCb);
          } else {
            resolve(resCb);
          }
        }),
      );
    });
  };

  const assignRoom = (room) => {
    console.log("assignRoom called with room:", room);

    let data = { ...room };

    if (admissionDate && admissionTime) {
      const admissionDateTime = new Date(`${admissionDate}T${admissionTime}`);
      data.admissionDateTime = admissionDateTime.toISOString();
    }

    if (data.emergencystatus === true) {
      data.emergencyroomstatus.bookstatus = ROOM_STATUS_BOOKED;
    } else {
      data.roomStatus.bookstatus = ROOM_STATUS_BOOKED;
    }

    data.visitid = patient.visitId;

    return new Promise((resolve) => {
      dispatch(
        doctorActions.assignRoom(data, (resCb) => {
          if (resCb?.successMessages) {
            ServerResVal.success = "Room booked successfully";
            setServerRes({ ...ServerResVal });
            props.closeRoomModal(ServerResVal);
          }
          if (resCb?.errorMessages) {
            ServerResVal.error =
              resCb.errorMessages?.[0] || "Failed to allocate room";
            setServerRes({ ...ServerResVal });
            props.closeRoomModal(ServerResVal);
          }
          console.log("ServerRes:", ServerResVal);
          resolve(resCb);
        }),
      );
    });
  };

  const checkoutRoom = (event) => {
    console.log("Checkout room:", event, assignedRoom);
    roomCheckout(assignedRoom, "checkout");
  };

  return (
    <>
      <main className="">
        {ServerRes.success && (
          <Alert severity="success" className="alert-div">
            {ServerRes.success}

            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}

        {ServerRes.error && (
          <Alert severity="error" className="alert-div">
            {ServerRes.error}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}

        {roomData && (
          <Dialog
            className="d-flex flex-column-reverse "
            id="room"
            open={openRoomModal}
            size="lg"
          >
            <div>
              <DialogTitle style={{ marginLeft: "14px" }}>
                Room Details
              </DialogTitle>
              <DialogContent>
                <div className="w-50 ml-3 pb-0">
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "14px",
                    }}
                  >
                    Visit Date:{" "}
                  </span>
                  <span style={{ fontSize: "14px" }}>
                    {getFormateDate(props.patientInfo.visitDate)}
                  </span>
                </div>
                <div className="w-50 ml-3 pb-0">
                  <FormControlLabel
                    control={
                      <Switch
                        inputRef={toggleSwitchRef}
                        checked={showEmergency}
                        onChange={toggleRooms}
                        onKeyDown={handleToggleKeyDown} // Add this
                        color="primary"
                      />
                    }
                    label={
                      showEmergency
                        ? "Show Normal Rooms"
                        : "Show Emergency Rooms"
                    }
                  />
                </div>
                <IconButton
                  ref={closeButtonRef} // Add this ref
                  aria-label="close"
                  onClick={(event) => closeRoomModal(event)}
                  onKeyDown={handleCloseKeyDown} // Add this
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogContent>
              <DialogContent>
                <div
                  className="ag-theme-balham ag-style px-3 pb-4"
                  style={{ height: "300px" }}
                >
                  <AgGridReact
                    key={showEmergency}
                    ref={gridRef}
                    frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    context={context}
                    rowData={roomData}
                    columnDefs={columnDefs}
                    rowSelection={"single"}
                    suppressRowClickSelection={false}
                    isRowSelectable={isRowSelectable}
                    onSelectionChanged={onSelectionChanged}
                    onRowDataChanged={onRowDataChanged}
                    getRowClass={getRowClass}
                    getRowStyle={getRowStyle}
                  ></AgGridReact>
                </div>
                {showEarlyCheckinWarning && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "4px",
                      marginRight: "12px",
                    }}
                  >
                    Warning: Check-in date/time is earlier than admission
                    date/time.
                  </span>
                )}
                <div
                  className="d-flex align-items-center justify-content-end gap-3 mt-3 px-3"
                  style={{ flexWrap: "nowrap" }}
                >
                  <span style={{ fontSize: "15px" }}>Room Assigned at </span>

                  <TextField
                    inputRef={checkinDateRef}
                    name="admissionDate"
                    label="Check-in Date"
                    type="date"
                    value={admissionDate}
                    onChange={(e) => setAdmissionDate(e.target.value)}
                    onKeyDown={handleDateKeyDown}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                  />

                  <TextField
                    inputRef={checkinTimeRef}
                    name="admissionTime"
                    label="Check-in Time"
                    type="time"
                    value={admissionTime}
                    onChange={(e) => setAdmissionTime(e.target.value)}
                    onKeyDown={handleTimeKeyDown}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                  />

                  <Button
                    ref={assignBtnRef}
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "capitalize", height: "40px" }}
                    disabled={isAssigning}
                    onClick={assignSelectedRoom}
                    onKeyDown={handleAssignKeyDown}
                  >
                    Assign / Checkout Room
                  </Button>
                </div>
              </DialogContent>
            </div>
          </Dialog>
        )}
      </main>
    </>
  );
}
export default Room;
